<template>
  <div
    id="app"
    class="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  mixins: [],
  data () {
    return {
    }
  },
  created () {
    // App Title
    document.title = '멀티캠퍼스'
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  },
  store: window.vue.getStore('root')
}
</script>



// WEBPACK FOOTER //
// src/App/App.vue